import { get, isEmpty, compact, isObject } from 'lodash'

import { EN_DASH_DEFAULT_VALUE } from 'utils/constants/defaultValues'
import { formatValue } from 'utils/formatters/value'

/**
 * Format user full name in format `${lastName}, ${firstName} ${middleNameFirstLetter}.` if all needed data is provided
 * if there is no $middleName - return `${lastName}, ${firstName}`
 */
export const formatFullNameWithMiddleInitial = ({ firstName = '', lastName = '', middleName = '' }) => {
  const firstNameFormatted = formatValue(firstName)
  const lastNameFormatted = formatValue(lastName)
  const middleNameFirstLetter = formatValue(middleName[0], '')

  if (!middleNameFirstLetter) {
    return compact([lastNameFormatted, firstNameFormatted]).join(', ')
  }

  return `${firstNameFormatted} ${middleNameFirstLetter}. ${lastNameFormatted}`
}

export const formatFullNameWithMiddleInitialFirst = (user, defaultValue = EN_DASH_DEFAULT_VALUE) => {
  if (isEmpty(user) || !isObject(user)) {
    return defaultValue
  }

  const firstName = formatValue(get(user, 'firstName'), '')
  const lastName = formatValue(get(user, 'lastName'), '')
  const middleNameFirstLetter = formatValue(get(user, 'middleName.[0]'), '')

  if (middleNameFirstLetter) {
    return `${firstName} ${middleNameFirstLetter}. ${lastName}`
  } else {
    return `${firstName} ${lastName}`
  }
}
